module.exports = __webpack_public_path__ + "img/lk-white-transparent.f631881a.png";